import { getFormattedDate } from '@app/utils/date'

import { dateFormat } from '@app/constants'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { TotalMonitoringDataSource } from '../types'
import type { PostMonitoringTasksTotalAllData } from '@app/api/routes/monitoringTasks/types'
import type { MonitoringListTotalCreatingTasksDto } from '@app/api/routes/monitoringLists/dtos'
import type { DecodedValueMap } from 'use-query-params'
import type { QueryParamConfigMap } from 'serialize-query-params'

export const adaptTotalMonitoringDataSource = (
  monitoringListTotalCreatingTasksResponse: ResponseDto<MonitoringListTotalCreatingTasksDto>
): TableData<TotalMonitoringDataSource> => {
  const { count, results: monitoringListTotalCreatingTasks } = monitoringListTotalCreatingTasksResponse

  const dataSource: TotalMonitoringDataSource[] = monitoringListTotalCreatingTasks.map(dto => ({
    key: dto.runParameters.id,
    runParametersId: dto.runParameters.id,
    store: dto.store?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    contractor: dto.runParameters.contractor?.name ?? null,
    contractorId: dto.runParameters.contractor?.userId ?? null,
    competitors: dto.runParameters.competitors,
    recommendation: dto.runParameters.referralRecommendation ?? null,
    isLaunchAccess: dto.isLaunchAccess,
    startAt: getFormattedDate(dto.runParameters.monitoringStartAtDatetime, dateFormat.DD_MM_YYYY),
    gettingDateAt: getFormattedDate(dto.runParameters.receivingDataDeadlineDatetime, dateFormat.DD_MM_YYYY_HH_mm),
    processingDateAt: getFormattedDate(dto.runParameters.processingDataDeadlineDatetime, dateFormat.DD_MM_YYYY_HH_mm),
    dateDeadline: getFormattedDate(dto.runParameters.newDataDeadlineDatetime, dateFormat.DD_MM_YYYY_HH_mm)
  }))

  return { count, dataSource }
}

export const adaptPostMonitoringTasksTotalAllData = (
  queryParams: DecodedValueMap<QueryParamConfigMap>
): PostMonitoringTasksTotalAllData => {
  return {
    storeIds: queryParams.storeIds,
    excludedStoreIds: queryParams.excludedStoreIds,
    clusterIds: queryParams.clusterIds,
    excludedClusterIds: queryParams.excludedClusterIds,
    salesOrganizationIds: queryParams.salesOrganizationIds,
    excludedSalesOrganizationIds: queryParams.excludedSalesOrganizationIds,
    contractorIds: queryParams.contractorIds,
    excludedContractorIds: queryParams.excludedContractorIds
  }
}
